import { render, staticRenderFns } from "./BuyIng.vue?vue&type=template&id=0b546629&scoped=true&"
import script from "./BuyIng.vue?vue&type=script&lang=js&"
export * from "./BuyIng.vue?vue&type=script&lang=js&"
import style0 from "./BuyIng.vue?vue&type=style&index=0&id=0b546629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b546629",
  null
  
)

export default component.exports